/**
 * «Scorri» cue at the foot of a full-screen hero (Verde Valsesia 2, Verde
 * Vercelli 2): the word in small spaced caps over a thin rule with a drop of
 * light running down it (`scroll-cue`, index.css; still under reduced motion).
 *
 * A link to the band after the hero, so a click scrolls there (the page's
 * smooth scroll) and it works without JS; the visible word is its name. The
 * outer box does the centring and the inner link the entrance (`fade-rise`
 * after the hero's CTA), so the entrance transform never fights the
 * `-translate-x-1/2`. `pl-[0.3em]` balances the tracking's trailing space so
 * the word sits centred over the rule. White on the hero's dark veil, with a
 * shadow like the hero's own lines.
 *
 * `compact` (Verde Valsesia 2, owner 2026-09-25: "a bit smaller and on the
 * bottom", then "lower, shorter line"; Verde Vercelli 2 matched 2026-09-28): a 10 px label over a 16 px rule,
 * 4 px apart, sitting on the hero's foot (2 px of the link's padding under
 * the rule) instead of 1.5rem up. The drop keeps the rule's proportion (its
 * keyframe runs 340% of its own height), so it still travels the whole rule.
 */
export function ScrollCue({ href, label, compact = false }: { href: string; label: string; compact?: boolean }) {
  return (
    <div className={`absolute left-1/2 z-10 -translate-x-1/2 ${compact ? 'bottom-0' : 'bottom-6'}`}>
      <a
        href={href}
        className={`fade-rise group flex flex-col items-center rounded-md px-2 text-white ${compact ? 'gap-1 pt-1 pb-0.5' : 'gap-2 py-1'}`}
        style={{ animationDelay: '1.1s' }}
      >
        <span
          className={`pl-[0.3em] font-semibold uppercase tracking-[0.3em] opacity-85 transition-opacity [text-shadow:0_1px_2px_rgba(0,0,0,0.85)] group-hover:opacity-100 ${compact ? 'text-[10px]' : 'text-[11px]'}`}
        >
          {label}
        </span>
        <span aria-hidden="true" className={`relative block w-px overflow-hidden bg-white/35 ${compact ? 'h-4' : 'h-10'}`}>
          <span className={`scroll-cue-drop absolute inset-x-0 top-0 block bg-white ${compact ? 'h-[5px]' : 'h-3'}`} />
        </span>
      </a>
    </div>
  )
}
